import { Injectable } from '@angular/core';
import { MdDialogConfig, MdDialogRef, MdDialog } from '@angular/material';
import { DialogAlertComponent } from '../../components/modal/dialog-alert/dialog-alert.component';
import { AppConfigService } from '../app-config/app-config.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Injectable()
export class WarningService {

  private errorRequestCount = 0;

  constructor(
    private dialog: MdDialog,
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService

  ) { }

  popDialogErrorRequest(alertText: string, fetchFunction?: Function, parameter?: any, redirectPath = '/', alertHeader?: string) {
    this.errorRequestCount += 1;

    const config = new MdDialogConfig();
    const dialogRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent, config);
    dialogRef.componentInstance.alertText = this.appConfigService.getTranslate(alertText) ? this.appConfigService.getTranslate(alertText) : alertText;
    dialogRef.componentInstance.alertHeader = this.appConfigService.getTranslate(alertHeader) ? this.appConfigService.getTranslate(alertHeader) : alertHeader;
    dialogRef.afterClosed().subscribe(result => {
      if (fetchFunction && this.errorRequestCount < 3) {
        parameter ? fetchFunction(parameter) : fetchFunction();
      } else {
        this.errorRequestCount = 0;
        this.utilitiesService.redirectPage(redirectPath, this.appConfigService.getLanguage());
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/warning/warning.service.ts